import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "影视分类", path: "/category" },
  { label: "搜索", path: "/search" },
  { label: "关于我们", path: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-100/90 backdrop-blur-xl border-b border-background-300/70"
          : "bg-gradient-to-b from-background-50/90 to-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-moon-fill text-xl md:text-2xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-extrabold tracking-wide text-foreground-950 text-base md:text-lg">
                午夜免费视频
              </span>
              <span className="hidden sm:block text-[11px] tracking-[0.28em] text-primary-400 font-label mt-0.5">
                MIDNIGHT
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                  isActive(item.path)
                    ? "text-primary-400 bg-primary-500/10"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/search"
              className="hidden md:flex items-center gap-2 h-10 px-4 rounded-md bg-background-200/80 border border-background-300/70 text-foreground-700 hover:text-foreground-950 hover:border-primary-500/60 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-base"></i>
              <span className="text-sm">搜索影视</span>
            </Link>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 rounded-md flex items-center justify-center bg-background-200/80 border border-background-300/70 text-foreground-950 cursor-pointer"
            >
              <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-300/70 bg-background-100/95 backdrop-blur-xl">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? "text-primary-400 bg-primary-500/10"
                    : "text-foreground-700 hover:bg-background-200/70"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/search"
              className="mt-2 flex items-center justify-center gap-2 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium"
            >
              <i className="ri-search-line text-base"></i>
              搜索影视内容
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}